module.exports = __webpack_public_path__ + "static/img/107.a706b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/107.jpg
// module id = mVlp
// module chunks = 0